import { graphql, useStaticQuery } from 'gatsby';
import { useExhibitors } from '@bottlebooks/gatsby-theme-event/src/components/SiteSearch/useEventData';
import useExhibitorImages from './useExhibitorImages';
import type { UseBottlebooksDataQuery } from './@types/useBottlebooksData.generated';

export default function useBottlebooksData() {
  const registrations = useRegistrations();
  return {
    addRegistration(exhibitor) {
      const registration = registrations.find(
        (registration) => registration.companyId === exhibitor.exhibitorId
      );
      return {
        ...exhibitor,
        ...registration,
      };
    },
  };
}

export function usePremiumExhibitors() {
  const allRegistrations = useRegistrations();
  const exhibitors = useExhibitors();
  const images = useExhibitorImages();
  return allRegistrations
    ?.filter(
      (registration) =>
        registration.exhibitorPackage?.__typename ===
          'Bottlebooks_SelectFieldValue' &&
        ['premium', 'pavilion'].includes(registration.exhibitorPackage?.key)
    )
    .map((registration) => ({
      ...registration,
      ...exhibitors.findById(registration.companyId),
      ...images.getImages(registration.companyId),
    }));
}

function useRegistrations() {
  const data = useStaticQuery<UseBottlebooksDataQuery>(graphql`
    query useBottlebooksData {
      bottlebooks {
        event(eventId: "620623d7b77ba18d7f4f7748", locale: de) {
          eventId
          registrations {
            nodes {
              companyId
              ...vv_ExhibitorCard_Registration
              exhibitorPackage: customFieldValue(key: "exhibitorPackage") {
                __typename
                ... on Bottlebooks_SelectFieldValue {
                  key
                }
              }
            }
          }
        }
      }
    }
  `);
  return data.bottlebooks.event.registrations.nodes;
}
